<e-dialog [open]="open()" (openChange)="onOpenChange($event)" [title]="title()" size="md">
  <ng-template>
    <div class="e-export" data-test-id="export-dialog">
      @if (intro()) {
        <p class="e-export__intro">{{ intro() }}</p>
      }

      @if (options().length > 1) {
        <div class="e-export__options" role="radiogroup" [attr.aria-label]="title()">
          @for (option of options(); track option.id) {
            <button
              type="button"
              role="radio"
              class="e-export__option"
              [class.is-active]="option.id === current()?.id"
              [attr.aria-checked]="option.id === current()?.id"
              (click)="select(option.id)"
              [attr.data-test-id]="'export-option-' + option.id"
            >
              <i [class]="'fas fa-' + option.icon + ' e-export__option-icon'" aria-hidden="true"></i>
              <span class="e-export__option-text">
                <span class="e-export__option-title">{{ option.title }}</span>
                <span class="e-export__option-sub">{{ option.description }}</span>
              </span>
            </button>
          }
        </div>
      } @else {
        <!-- Eén formaat: geen keuze, wel dezelfde kop. (`as` mag niet op @else if.) -->
        @if (current(); as single) {
          <div class="e-export__option e-export__option--single">
            <i [class]="'fas fa-' + single.icon + ' e-export__option-icon'" aria-hidden="true"></i>
            <span class="e-export__option-text">
              <span class="e-export__option-title">{{ single.title }}</span>
              <span class="e-export__option-sub">{{ single.description }}</span>
            </span>
          </div>
        }
      }

      @if (current(); as option) {
        <div class="e-export__info" data-test-id="export-info">
          @if (option.includes.length > 0) {
            <h5 class="e-export__info-title">
              <i class="fas fa-check" aria-hidden="true"></i>
              {{ labels().includes }}
            </h5>
            <ul class="e-export__list" data-test-id="export-includes">
              @for (item of option.includes; track $index) {
                <li>{{ item }}</li>
              }
            </ul>
          }
          @if (option.excludes.length > 0) {
            <h5 class="e-export__info-title e-export__info-title--excluded">
              <i class="fas fa-xmark" aria-hidden="true"></i>
              {{ labels().excludes }}
            </h5>
            <ul class="e-export__list" data-test-id="export-excludes">
              @for (item of option.excludes; track $index) {
                <li>{{ item }}</li>
              }
            </ul>
          }
          @if (option.note) {
            <p class="e-export__note">{{ option.note }}</p>
          }
        </div>
      }

      <div class="e-export__actions">
        <button eBtn color="primary-75" icon="download" type="button" [loading]="busy()" [disabled]="busy()" (click)="submit()" data-test-id="export-download">
          {{ labels().download }}
        </button>
      </div>
    </div>
  </ng-template>
</e-dialog>
